import { Controller } from "@hotwired/stimulus"

/** Previsualización del logo en portal/carta (URL → img). */
export default class extends Controller {
  static targets = ["input", "preview", "empty"]
  static values = {
    emptyText: String,
    errorText: String
  }

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const raw = (this.inputTarget.value || "").trim()
    const img = this.previewTarget
    const empty = this.emptyTarget

    img.onload = null
    img.onerror = null

    if (!raw || !this.isHttpUrl(raw)) {
      img.removeAttribute("src")
      img.classList.add("hidden")
      empty.classList.remove("hidden")
      empty.textContent = this.emptyTextValue
      return
    }

    img.onload = () => {
      img.classList.remove("hidden")
      empty.classList.add("hidden")
    }
    img.onerror = () => {
      img.removeAttribute("src")
      img.classList.add("hidden")
      empty.classList.remove("hidden")
      empty.textContent = this.errorTextValue
    }
    img.src = raw
  }

  isHttpUrl(s) {
    try {
      const u = new URL(s)
      return u.protocol === "https:" || u.protocol === "http:"
    } catch {
      return false
    }
  }
}
